<template>
  <div class="contenedor col-sm-12">
    <Aside :windowWidth="windowWidth" v-if="windowWidth > 767" />
    <menu class="col-sm-10">
      <header>
        <div class="d-block d-sm-none">
					<router-link :to="{name: 'mis-creditos'}"> 
            <img src="https://static.bienparabien.com/apps/img/logo_gradiente.png" alt="Logo BpB" width="60px">
          </router-link>
				</div>
        <Main :windowWidth="windowWidth"/>
				<MainMobile v-if="windowWidth < 767"/>
      </header>

      <div class="content">
        <router-view/>
      </div>
			<Footer />
    </menu>
  </div>
</template>

<script type="text/javascript">
	import Aside from './Aside.vue'
	import Main from './Main.vue'
	import MainMobile from "./MainMobile"
	import Footer from './Footer'

	export default {
		components: {
			Aside,
			Main,
			MainMobile,
			Footer
		},

		data() {
			return {
				windowWidth: window.innerWidth,
			}
		},

		created() {
			this.windowWidth = window.innerWidth;
			window.addEventListener('resize', () => {
				this.windowWidth = window.innerWidth;
			})
		}
	}
</script>

<style lang="scss" scope>
@import '@/styles/index.scss';

	.contenedor {
		width: 100vw;
		min-height: 100vh;
		margin: 0px;
		padding: 0px;
		display: flex;
		flex-direction: row;
		overflow: auto;
	}
</style>